import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Lease } from '../models';
import { staticUrl } from '../utils/staticAsssets';

interface RouteParams {
  filename: string;
}

export function ExplainerRedirect() {
  const { filename } = useParams<RouteParams>();
  const redirectUrl = `${staticUrl}/${Lease.getExplainerLeasePath(filename)}`;
  useEffect(() => {
    window.location.replace(redirectUrl);
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- preserving existing behavior; not re-verified
  }, []);

  return null;
}

export default ExplainerRedirect;
